export * from './ZoomOutIcon'
